import config from "config/config";
import { Link } from "react-router-dom";
export default function SimpleCallToActionCard({
  title,
  desc,
  ctaText,
  ctaUrl,
  isUrlNeedToOpenInNewTab = false,
  performSubmit,
}) {
  return (
    <div className="ui-card p-4 xl:p-6">
      <div className="text-xl font-semibold">{title}</div>
      <hr />
      <p className="text-xs">{desc}</p>
      <div className="text-right mt-4 xl:mt-6">
        {ctaUrl !== "disable" &&
          (isUrlNeedToOpenInNewTab && config.CALCFOCUS_SERVICE_BASE_URL ? (
            <button
              className="ui-btn-primary"
              type="button"
              onClick={() => performSubmit()}
            >
              {ctaText}
            </button>
          ) : isUrlNeedToOpenInNewTab ? (
            <a href={ctaUrl} target="_blank" rel="noreferrer">
              <button className="ui-btn-primary">{ctaText}</button>
            </a>
          ) : (
            <Link to={ctaUrl}>
              <button className="ui-btn-primary">{ctaText}</button>
            </Link>
          ))}
      </div>
    </div>
  );
}
